import React, {useState} from 'react';
import {useSelector} from "react-redux";
import {
    bbFindCustomerTagsByTagId,
    bbFindEntityWithinPortfolioOrSelf,
    isCurrentUserMemberOf
} from "../../../util/bbHelpers";
import {useHistory} from "react-router-dom";
import {makeStyles} from "@material-ui/core/styles";
import Backdrop from "@material-ui/core/Backdrop";
import { Paper} from "@material-ui/core";
import {Col, Row} from "reactstrap";
import BBCodeCopyContainer from "../controllers/BBCodeCopyContainer";
import BBExternalLink from "../accents/BBExternalLink";
import BBIconCodeDocument from "../../../assets/bbCustomIcons/BBIconCodeDocument";
import AlertDialog from "../modals/PopupAlert";


//TODO: this is a legacy styling solution and should be updated to reflect newer MUI
const useStyles = makeStyles(theme => ({
    backdrop: {
        zIndex: theme.zIndex.drawer + 1,
        color: '#fff',
        // filter: `blur(3px)`,

    },

    parent: {
        position: "absolute",
        top:0,
        left:0,
        right:0,
        bottom:0,
        // backgroundColor: "rgba(255, 255, 255, 0.25)",
        zIndex: "2000",
        borderRadius: "8px",
        pointerEvents: "all",
    },
    child: {
        filter: `blur(5px)`,
        pointerEvents: "none",

    },
    container: {
        position: "relative",
        width: "100%",
        height: "100%",
        // margin: 0,
        // padding: 0,

    },
    paper: {
        // position: 'fixed',
        // top:0,
        // left:0,
        // right:0,
        // bottom:0,
        // width: 600,
        minWidth: 400,
        maxWidth: 800,
        // backgroundColor: theme.palette.background.paper,
        border: '2px solid #000',
        boxShadow: theme.shadows[5],
        padding: theme.spacing(4, 8, 6),
    },
}));

const SocialEngineeringIsOffModal = ({children}) =>{

    const classes = useStyles();

    const history = useHistory();
    const {customers, customerInView} = useSelector(({customer}) => customer);
    const authUser = useSelector(({auth}) => auth.authUser);
    const {entityInView, portfolios} = useSelector(({breachrisk})=> breachrisk);
    const isAdminStaff = isCurrentUserMemberOf(authUser, "admin") || isCurrentUserMemberOf(authUser, "staff");
    const customer = customers ? customers[customerInView] : null;

    const customerIdToUse = customers ? customerInView ? customerInView : null : null;

    const [open, setOpen] = useState(true);

    const myEntity = bbFindEntityWithinPortfolioOrSelf(entityInView, portfolios, customerIdToUse);

    const currentPage = history.location.pathname;

    // const arrayOfPagesNeedingVerification = [`/board/BreachRisk/Business/Share/Current`, `/board/BreachRisk/Business/Verifications`,`/board/BreachRisk/Business/Attestations`, `/board/BreachRisk/Business/Report/TechData`, `/board/BreachRisk/Business/Report/Social`, `/board/BreachRisk/Business/CloudIntegration` ];

    const dontDoSocialTags = bbFindCustomerTagsByTagId(customer, 80);
    const dontDoSocial = dontDoSocialTags && dontDoSocialTags.length > 0; //if there is at least one dont social tag, then qualifies
    // console.log("checking for social tag within SocialEngineeringIsOffModal.js", "customer", customer, "dontDoSocialTags", dontDoSocialTags, "dontDoSocial", dontDoSocial);


    // const ownershipVerified = myEntity
    //     && myEntity.onboarding_progress
    //     && myEntity.onboarding_progress.verified_ownership;

    // const verification_id = myEntity
    //     && myEntity.domains
    //     && Object.values(myEntity.domains)
    //     && Object.values(myEntity.domains).find(x=> x.is_primary)
    //     && Object.values(myEntity.domains).find(x => x.is_primary).verification
    //     && Object.values(myEntity.domains).find(x => x.is_primary).verification.verification_id;

    // console.log("Verifiedownership", ownershipVerified);

    const stillLoadingData = !myEntity || !currentPage;

    if(stillLoadingData){
        return children;
    } else if(dontDoSocial && isAdminStaff){
        return<>
        <AlertDialog
            title={"Heads Up"}
            description={'You have access to this because you are an admin, but this company has social engineering disabled via tag 80.'}
        />
            {children}
        </>
    } else if(dontDoSocial){
        return(
            <div className={classes.container}>
                <div className={classes.parent}>
                    <Backdrop className={classes.backdrop} open={true}>
                        <Paper className={"p-3 "} style={{ textAlign: "center" }}>
                            <div className={classes.paper}>
                                <Row>
                                    <Col>
                                        <h1>
                                            You Don't Have Access to Social Engineering
                                        </h1>
                                    </Col>
                                </Row>

                                <>
                                    <Row>
                                        <Col>
                                            <h4> Your account is specially configured to not include Social Engineering. If you believe this is an error, please contact BreachBits support at support@breachbits.com.</h4>
                                        </Col>
                                    </Row>

                                </>

                            </div>
                        </Paper>
                    </Backdrop>
                </div>

                <div className={classes.child}>
                    {children}
                </div>
            </div>

        )
    } else{
        return children
    }


}

export default SocialEngineeringIsOffModal;